const PIXEL_ID = '719763334496638'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as any[]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  f.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  const fbq = (window as any).fbq
  if (fbq) fbq('track', 'PageView')
}

export function trackAddToCart() {
  const fbq = (window as any).fbq
  if (fbq) fbq('track', 'AddToCart')
}
